import React from 'react';
import { TemplateApp } from './template/TemplateApp';

export default function App() {
  return <TemplateApp />;
}

